import React, { useState } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './Header.module.scss'
import Logo from '../../assets/logo.svg'
import PlatformSwitcher from '../platform-switcher/PlatformSwitcher'
import Cta from '../cta/Cta'
import Burger from '../burger/Burger'
import ExternalIcon from '../../assets/external.svg'

const Header: React.FC = () => {
  const t = useIntl()
  const [menuOpen, setMenuOpen] = useState<boolean>(false)

  function handleBurgerClick () {
    setMenuOpen(true)
  }

  function handleOverlayClick () {
    setMenuOpen(false)
  }

  return (
    <>

      <div className={styles.headerWrapper}>
        <header className={styles.container}>

          <div className={styles.headerLeft}>
            <Logo className={styles.logo} />
          </div>

          <div className={styles.headerCenter}>
            <div className={styles.switcher}>
              <PlatformSwitcher />
            </div>
          </div>

          <div className={styles.headerRight}>
            <div className={styles.ctas}>
              <a
                className={styles.login}
                href='/login'
                data-test='Login-cta'
              >
                {t.formatMessage({ id: 'header.login' })}
              </a>
              <Cta
                className={styles.cta}
                content={t.formatMessage({ id: 'header.cta' })}
              />
            </div>
            <div className={styles.burgerWrapper}>
              <Burger onClick={handleBurgerClick} />
              <a
                className={styles.signup}
                href='/signup'
              >
                {t.formatMessage({ id: 'header.signup' })}
              </a>
            </div>
          </div>
          <div
            className={styles.menu}
            style={{ transform: menuOpen ? 'translateY(0%)' : 'translateY(-100%)' }}
          >
            <div className={styles.buttons}>
              <a
                className={styles.mobileLogin}
                href='/login'
              >
                {t.formatMessage({ id: 'header.login' })}
              </a>
              <a
                className={styles.signup}
                href='/signup'
              >
                {t.formatMessage({ id: 'header.signup' })}
              </a>
            </div>
            <a
              className={styles.externalLink}
              target='_blank'
              href='https://codingame.com/work'
              rel='noreferrer'
            >
              {t.formatMessage({ id: 'header.coderpadLink' })}
              <ExternalIcon
                width={16}
                height={16}
              />
            </a>
          </div>
        </header>
      </div>
      <div
        style={{
          opacity: menuOpen ? 1 : 0,
          pointerEvents: menuOpen ? 'auto' : 'none'
        }}
        className={styles.overlay}
        onClick={() => handleOverlayClick()}
      />
    </>
  )
}

export default Header
